import { useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";

const Toaster = (props) => {
  const {
    show,
    title,
    toastType,
    position,
    theme,
    rtl,
    closeButton,
  } = props;

  const lastMsgRef = useRef("");
  const closeButtonRef = useRef(closeButton);
  closeButtonRef.current = closeButton;

  useEffect(() => {
    if (!show) {
      lastMsgRef.current = "";
      return;
    }

    const key = `${toastType}:${title}`;
    if (lastMsgRef.current === key) return;

    lastMsgRef.current = key;

    const onClose = () => closeButtonRef.current?.();

    if (toastType === "success") {
      toast.success(title, { toastId: key, onClose });
    } else if (toastType === "failure") {
      toast.error(title, { toastId: key, onClose });
    } else if (toastType === "info") {
      toast.info(title, { toastId: key, onClose });
    } else if (toastType === "warning") {
      toast.warn(title, { toastId: key, onClose });
    } else {
      toast(title, { toastId: key, onClose });
    }
  }, [show, toastType, title]);

  return (
    <ToastContainer
      position={position || "top-right"}
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={true}
      rtl={rtl || false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme || "dark"}
    />
  );
};

export default Toaster;

/**
 * To call the toaster
 * const [show, isSHow] = useState(false);
 * const closeButton = () => {
   isShowToaster(false);
  };
 * <Toaster
        show={show}
        toastType={"success"} // Pass the desired type
        title={"wow so easy"} '' Title to show
        theme={"light"}
        position="top-center"
        closeButton={()=>{}}
      />
 * 
 * 
*/
